import React from 'react';
import './Main.scss';
import { identity } from "../../utils/getIdentity";

export default function Main(p) {
  return <div className={`admin-pages-wrapper admin-pages-wrapper-${identity}`}>{p.children}</div>;
}
